import * as TypeAction from './actionTypes'

import { salvaModeloRelatorio, listAllModeloRelatorio, listAllRelatorioUser, listAllRelatorioPublico } from './api';

import { actionSincCRUD, actionSyncListObj } from 'scorpion-core';
import { userUid } from '../../../firebase'
export const setJsonGerarOkReportDeveloper = (dados, meta) => (dispatch) => {
    let json = { dados, meta: meta }

    dispatch({ type: TypeAction.SET_JSON_GERAR, payload: json });
}

export const salvar = (modeloRelatorio) => (dispatch) => {
    if (!modeloRelatorio.users) {
        let users = {}
        users[userUid()] = true;
        modeloRelatorio.users = users
    }

    actionSincCRUD(salvaModeloRelatorio(modeloRelatorio), TypeAction.SALVAR, dispatch)
}

export const listar = () => (dispatch) => {
    listAllModeloRelatorio(actionSyncListObj(TypeAction.LISTAR, dispatch))
}

export const listarRelatoriosUser = () => (dispatch) => {

    listAllRelatorioUser(userUid(), actionSyncListObj(TypeAction.LISTAR_RELATORIOS_USER, dispatch))
    listAllRelatorioPublico(actionSyncListObj(TypeAction.LISTAR_RELATORIOS_PUBLICO, dispatch))
}




// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/actions.js